module.exports = __webpack_public_path__ + "fonts/DM_Sans-700-latin-ext14.49935c4.woff2";